import { render } from "./EnNotificationListItem.vue?vue&type=template&id=281fa2ca&ts=true"
import script from "./EnNotificationListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnNotificationListItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/notifications/EnNotificationListItem/EnNotificationListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "281fa2ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('281fa2ca', __exports__)) {
    api.reload('281fa2ca', __exports__)
  }
  
  module.hot.accept("./EnNotificationListItem.vue?vue&type=template&id=281fa2ca&ts=true", () => {
    api.rerender('281fa2ca', render)
  })

}


export default __exports__